
// blog slider js
jQuery('.blog-slide-class').slick({
  dots: false,
  infinite: false,
  arrows:false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// quantity selector js
$('.swatch_varinat').on('click', function(){
  var vid = $(this).data("vid");
  console.log(vid);
  $("#variant_id").val(vid);
}); 
// quantity selector js
$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 

// thumb slide

 $('.product-media-full').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  asNavFor: '.product-media-thumb'
});



$('.product-media-thumb').slick({
  slidesToShow: 5,
  slidesToScroll: 5,
  asNavFor: '.product-media-full',
  dots: false,
  arrows:false,
  focusOnSelect: true,
  infinite: false,
   responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        centerMode: false
      }
    },
     {
      breakpoint: 576,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        centerMode: false
      }
    }
  ]
});


// mobile menu js
$(document).ready(function(){ 

 $(".mobile-search-icon").click(function() { 
    $("#SearchDrawer").fadeIn("slow");
});

 $(".close-icon-main a").click(function() { 
      $("#SearchDrawer").fadeOut("slow"); 
    });
 });


// 4season page slide
 $('.img_slide-class').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  infinite: false
});


// popup video
  $(document).ready(function() {
    $('.popup-youtube').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      fixedContentPos: false
    });
  });

// product slider
$('.product_slider_class').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1
      }
    }
  ]
});




// Brand slider
$('.brand_logo_slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 767,
      settings: "unslick"
    }
  ]
});

// BLog slider
$('.blog_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1
      }
    }
  ]
});

// colection moile slider
$(document).ready(function () {
	$('.product_slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		mobileFirst: true,
		infinite: false,
		responsive: [{
			breakpoint: 767,
			settings: "unslick"
		}]
	});
});


//$(document).ready(function () {
  
//$('li.mega-menu-list').mouseover(function(e)
//{
   // e.stopPropagation();
   // $(this).children(".megamenu_downdown").css("display", "block");
//});

//$('li.mega-menu-list').mouseout(function()
//{
    // $(this).children(".megamenu_downdown").css("display", "none");
//});

//});